import { Fragment } from '@atlaskit/editor-prosemirror/model';
import { TextSelection } from '@atlaskit/editor-prosemirror/state';
import { findParentNodeOfType, findSelectedNodeOfType } from '@atlaskit/editor-prosemirror/utils';
import { CellSelection, findTable } from '@atlaskit/editor-tables';
export var findSyncBlock = function findSyncBlock(schema, selection) {
  var syncBlock = schema.nodes.syncBlock;
  return findSelectedNodeOfType(syncBlock)(selection);
};
export var findBodiedSyncBlock = function findBodiedSyncBlock(schema, selection) {
  return findSelectedNodeOfType(schema.nodes.bodiedSyncBlock)(selection) || findParentNodeOfType(schema.nodes.bodiedSyncBlock)(selection);
};
export var findSyncBlockOrBodiedSyncBlock = function findSyncBlockOrBodiedSyncBlock(schema, selection) {
  return findSyncBlock(schema, selection) || findBodiedSyncBlock(schema, selection);
};
export var isBodiedSyncBlockNode = function isBodiedSyncBlockNode(node, bodiedSyncBlock) {
  return node.type === bodiedSyncBlock;
};
var UNSUPPORTED_NODE_TYPES = new Set(['inlineExtension', 'extension', 'bodiedExtension', 'syncBlock', 'bodiedSyncBlock']);

/**
 * Checks whether the selection can be converted to sync block
 *
 * @param selection - the current editor selection to validate for sync block conversion
 * @returns A fragment containing the content to include in the synced block,
 * stripping out unsupported marks (breakout on codeblock/expand/layout), as well as from and to positions,
 * or false if conversion is not possible
 */
export var canBeConvertedToSyncBlock = function canBeConvertedToSyncBlock(selection) {
  var schema = selection.$from.doc.type.schema;
  var nodes = schema.nodes;
  var from = selection.from;
  var to = selection.to;
  var contentToInclude = selection.content().content;
  if (selection instanceof CellSelection) {
    var table = findTable(selection);
    if (!table) {
      return false;
    }
    contentToInclude = Fragment.from([table.node]);
    from = table.pos;
    to = table.pos + table.node.nodeSize;
  } else if (selection instanceof TextSelection) {
    var trueParent = findParentNodeOfType([nodes.bulletList, nodes.orderedList, nodes.taskList, nodes.blockquote])(selection);
    if (trueParent) {
      contentToInclude = Fragment.from([trueParent.node]);
      from = trueParent.pos;
      to = trueParent.pos + trueParent.node.nodeSize;
    }
  }
  var canBeConverted = true;
  selection.$from.doc.nodesBetween(from, to, function (node) {
    if (UNSUPPORTED_NODE_TYPES.has(node.type.name)) {
      canBeConverted = false;
      return false;
    }
  });
  if (!canBeConverted) {
    return false;
  }
  contentToInclude = removeBreakoutMarks(contentToInclude);
  return {
    contentToInclude: contentToInclude,
    from: from,
    to: to
  };
};
var removeBreakoutMarks = function removeBreakoutMarks(content) {
  var nodes = [];

  // we only need to recurse at the top level, because breakout has to be on a top level
  content.forEach(function (node) {
    var filteredMarks = node.marks.filter(function (mark) {
      return mark.type.name !== 'breakout';
    });
    if (node.isText) {
      nodes.push(node);
    } else {
      var newNode = node.type.create(node.attrs, node.content, filteredMarks);
      nodes.push(newNode);
    }
  });
  return Fragment.from(nodes);
};